import { Result } from "@pacote/result"
import useSWRMutation from "swr/mutation"
import { v4 as uuidV4 } from "uuid"
import { z } from "zod"
import { baseClientFetcher } from "./base-fetchers"
import {
  BaseLoginPayload,
  ComputedLoginFields,
  handleLoginResult,
  LoginErrorResponse,
  ssoLoginResponseSchema,
  TloginErrorResponse,
} from "./post-login-sso"

type OAuthLoginPayload = BaseLoginPayload & {
  pvd?: string
}

const oAuthLoginResponseSchema = ssoLoginResponseSchema.extend({
  redirect: z.string().optional(),
})

type OAuthLoginResponse = z.infer<typeof oAuthLoginResponseSchema>

export type TOAuthLoginResponse = OAuthLoginResponse & ComputedLoginFields

type OAuthLoginResult = Result<TOAuthLoginResponse, TloginErrorResponse>

export const oAuthLoginEndpoint = "/authentication-ms/v1/oauth/login"

const oAuthLoginFetcher = async (
  key: string,
  { arg }: { arg: OAuthLoginPayload },
): Promise<OAuthLoginResult> => {
  const sessionId = uuidV4()

  const loginServiceResult = await baseClientFetcher<
    OAuthLoginResponse,
    LoginErrorResponse
  >(
    {
      url: key,
      method: "POST",
      headers: {
        "X-Session-Id": sessionId,
      },
      body: {
        username: arg.username,
        password: arg.password,
        pvd: arg.pvd ?? "BO9999",
        recaptchaToken: arg.recaptchaToken,
      },
      successSchemaValidator: oAuthLoginResponseSchema,
      throwOnValidationError: true,
    },
    { enrichRequestData: false },
  )

  return await handleLoginResult(loginServiceResult, arg.channel, sessionId)
}

export const useOAuthLoginMutation = () =>
  useSWRMutation(oAuthLoginEndpoint, oAuthLoginFetcher, {
    populateCache: true,
  })
